import styled from 'utils/styled';

export const Container = styled.div``;

export const Section = styled.div`
  margin-bottom: 8px;
`;
